import AxiosManager from "../_axiosManager";

export async function postImage(body: any) {
  const res = await AxiosManager.getInstance().post("/upload/image", body);

  return res;
}

export async function postPark(body: any) {
  const res = await AxiosManager.getInstance().post("/admin/manage/park", body);

  return res;
}

export async function delPark(parkId: string) {
  const res = await AxiosManager.getInstance().delete(
    `/admin/manage/park/${parkId}`,
  );

  return res;
}

export async function putPark({ parkId, body }: any) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/park/${parkId}`,
    body,
  );

  return res;
}
